







































import CFMDialog from '@/scripts/CFMDialog'
import { Component, Vue } from 'vue-property-decorator';

import * as blockui from '@/helpers/block-ui'

import {required} from "vuelidate/lib/validators";

import { CFMDTOQualificationType } from '@/scripts/services/ClientApiAuto'

@Component<QualificationTypeDialog>({
    validations() {
        return {
          qualificationType:{
              Name: {required},
          },
        }
    },
})
export default class QualificationTypeDialog extends CFMDialog {
    qualificationType: CFMDTOQualificationType = {Name: ''};

    async created(){
      blockui.blockModal(this);
      if(this.isUpdate){
        const res = await this.apiClient.qualificationType.qualificationTypeGetById({id: <number>this.id});
        this.qualificationType = res.data;
      }
      blockui.unBlockModal();
    }

    get isUpdate() {
        return !!this.id;
    }

    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      
      let formData:CFMDTOQualificationType = {
        Id: this.qualificationType.Id,
        Name: this.qualificationType.Name,
      };

      blockui.blockModal(this);
      try{
        const response  = await this.apiClient.qualificationType.qualificationTypeSave(formData);
        if (response.data.IsSuccess) {
          toastr.success(this.translate('save_successfully'));
          this.saveSucceeded();
          this.close();
        } else {
          const errorMessage = response.data.Message ? response.data.Message : "Error";
          toastr.error(errorMessage);
        }
      }
      catch(e){
        console.log("err",e)
        toastr.error(e);
      }
      finally{
        blockui.unBlockModal();
      }
    }
}
